import type {
  SavedAddressDto,
  SavedAddressInput,
  SavedRecipientDto,
  SavedRecipientInput,
} from '@posilka/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

export const savedKeys = {
  addresses: ['saved', 'addresses'] as const,
  recipients: ['saved', 'recipients'] as const,
};

export const useSavedAddresses = () =>
  useQuery({
    queryKey: savedKeys.addresses,
    queryFn: () => api<SavedAddressDto[]>('/me/addresses'),
    staleTime: 5 * 60_000,
  });

export const useSavedRecipients = () =>
  useQuery({
    queryKey: savedKeys.recipients,
    queryFn: () => api<SavedRecipientDto[]>('/me/recipients'),
    staleTime: 5 * 60_000,
  });

export const useAddSavedAddress = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SavedAddressInput) =>
      api<SavedAddressDto>('/me/addresses', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: savedKeys.addresses }),
  });
};

export const useAddSavedRecipient = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SavedRecipientInput) =>
      api<SavedRecipientDto>('/me/recipients', { method: 'POST', body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: savedKeys.recipients }),
  });
};

export const useRemoveSaved = (kind: 'addresses' | 'recipients') => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api(`/me/${kind}/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: savedKeys[kind] }),
  });
};
